import React from "react";

export const FeaturesGPUAcceleration = (props) => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={56}
            height={57}
            viewBox="0 0 56 57"
            fill="none"
            {...props}
        >
            <path
                d="M43.476 9.5c-1.226 1.226-2.452 2.298-3.678 3.524-4.29 4.137-8.58 8.274-12.87 12.565l-1.686 1.685c-1.38 1.532-1.38 3.678.153 5.363 1.38 1.532 3.678 1.532 5.21.306.613-.46 1.072-1.225 1.532-1.838l8.734-16.089c.766-1.532 1.685-3.064 2.452-4.597 0-.46.153-.613.153-.919z"
                fill="#FE9235"
            />
            <path
                d="M35.617 10.582c-8.611-2.898-17.992.153-23.22 7.628-2.922 4.119-3.998 8.848-3.076 13.882 1.23 7.323 5.536 12.052 12.456 14.645 1.692.61 3.383.763 5.229.763l-3.691-.915c-5.69-1.983-9.38-5.797-10.918-11.594-2-7.933 2.153-15.56 9.226-18.307 3.998-1.525 7.997-1.525 11.841.458.461.152.615.152.923-.153 1.384-1.373 2.922-2.746 4.305-4.119.154-.152.154-.152.308-.457-1.076-.763-2.153-1.373-3.383-1.83zM42.25 14.403c-.613 1.073-1.072 2.146-1.685 3.065-.613 1.072-1.226 2.145-1.686 3.218-.153.153-.153.46-.153.613.613 1.072 1.226 2.145 1.839 3.37 2.298-1.072 4.75-2.145 7.048-3.217-1.226-2.758-2.911-5.057-5.363-7.049z"
                fill="#32393E"
            />
        </svg>
    )
}
